import React from "react";
import './LandingPage.css'
import Main from "./Main";
import Navbar from "./Navbar";
const LandingPage = () => {

    return <div id="home" className="landing-page" >
        <Navbar />
        <Main />
    </div>
};

export default LandingPage;